import CloudIcon from "@/assets/exercise-item-vector/feel-stressed/cloud.svg";
import EditIcon from "@/assets/exercise-item-vector/feel-stressed/edit.svg";
import LeafIcon from "@/assets/exercise-item-vector/feel-stressed/leaf.svg";
import RoseIcon from "@/assets/exercise-item-vector/feel-stressed/rose.svg";
import ImaginationIcon from "@/assets/exercise-item-vector/imagination.svg";
import FingerIcon from "@/assets/exercise-item-vector/hand-finger.svg";
import PencilIcon from "@/assets/exercise-item-vector/pencil.svg";
import TreeIcon from "@/assets/exercise-item-vector/icons-tree.svg";
import NetworkIcon from "@/assets/exercise-item-vector/icons-network.svg";
import StarIcon from "@/assets/exercise-item-vector/star.svg";
import ImagineIcon from "@/assets/exercise-item-vector/arcticons-imagine.svg";
import MoonIcon from "@/assets/exercise-item-vector/moon.svg";

import stressAdultImage from "@/assets/exercise-background-photos/stress.png";
import fearAdultImage from "@/assets/exercise-background-photos/fear.png";
import weaknessAdultImage from "@/assets/exercise-background-photos/weak.png";
import truamaAdultImage from "@/assets/exercise-background-photos/truama.jpg";
import substanceUseAdultImage from "@/assets/exercise-background-photos/substance-use.jpg";
import sleepAdultImage from "@/assets/exercise-background-photos/sleeping.jpg";
import concentrationAdultImage from "@/assets/exercise-background-photos/concentration.jpg";
import selfInflictedInjuriesAdultImage from "@/assets/exercise-background-photos/self-inflicted-injuries.jpg";
import guiltFeelingsAdultImage from "@/assets/exercise-background-photos/guilt-feelings.jpg";
import physicalPainAdultImage from "@/assets/exercise-background-photos/physical-pain.jpg";
import angerAdultImage from "@/assets/exercise-background-photos/anger.png";
import depressionAdultImage from "@/assets/exercise-background-photos/depression.png";
import anxietyAdultImage from "@/assets/exercise-background-photos/anixiety.png";
import suicideIdeationAdultImage from "@/assets/exercise-background-photos/suicide-ideation.png";
import nightmaresAdultImage from "@/assets/exercise-background-photos/nightmares.png";
import flashbacksAdultImage from "@/assets/exercise-background-photos/flashbacks.jpg";
import FlashbacksVideoMp4 from "@/assets/videos/adults-symptoms/flashbacks/flashbacks.mp4";
import FlashbacksVideoWebm from "@/assets/videos/adults-symptoms/flashbacks/flashbacks.webm";
import FlashbacksThumbnail from "@/assets/flashback-thumbnail.jpg";
import NightmaresVideoMp4 from "@/assets/videos/adults-symptoms/nightmares/nightmares.mp4";
import NightmaresVideoWebm from "@/assets/videos/adults-symptoms/nightmares/nightmares.webm";
import SarahVideoThumbnail from "@/assets/sarah-truama-vid-thumb.png";
import TraumaVideo1Mp4 from "@/assets/videos/adults-symptoms/trauma/trauma.mp4";
import TraumaVideo1Webm from "@/assets/videos/adults-symptoms/trauma/trauma.webm";
import TraumaVideo2Mp4 from "@/assets/videos/adults-symptoms/trauma/trauma-symptoms.mp4";
import TraumaVideo2Webm from "@/assets/videos/adults-symptoms/trauma/trauma-symptoms.webm";
import GriefAndLossPoster from "@/assets/grief-loss-thumbnail.png";
import GriefAndLossVideoMp4 from "@/assets/videos/children-symptoms/grief-and-loss.mp4";
import GriefAndLossVideoWebm from "@/assets/videos/children-symptoms/grief-and-loss.webm";
import UnderstandingDepressionPoster from "@/assets/understanding-thumbnail.png";
import UnderstandingDepressionVideoMp4 from "@/assets/videos/children-symptoms/understanding-depression-sadness.mp4";
import UnderstandingDepressionVideoWebm from "@/assets/videos/children-symptoms/understanding-depression-sadness.webm";
import SelfEsteemPoster from "@/assets/self-esteem-thumbnail.png";
import SelfEsteemVideoMp4 from "@/assets/videos/children-symptoms/self-esteem-identity.mp4";
import SelfEsteemVideoWebm from "@/assets/videos/children-symptoms/self-esteem-identity.webm";
import SleepProblemsPoster from "@/assets/sleep-problems-thumbnail.png";
import SleepProblemsVideoMp4 from "@/assets/videos/children-symptoms/sleep-problems.mp4";
import SleepProblemsVideoWebm from "@/assets/videos/children-symptoms/sleep-problems.webm";
import SelfHarmPoster from "@/assets/self-harm-thumbnail.jpg";
import SelfHarmVideoMp4 from "@/assets/videos/children-symptoms/self-harm.mp4";
import SelfHarmVideoWebm from "@/assets/videos/children-symptoms/self-harm.webm";
import GriefAndLossChildrenAr from "/subs/grief-and-loss.ar.vtt";
import GriefAndLossChildrenEn from "/subs/grief-and-loss.en.vtt";
import UnderstandingDepressionChildrenAr from "/subs/understanding-depression-sadness.ar.vtt";
import UnderstandingDepressionChildrenEn from "/subs/understanding-depression-sadness.en.vtt";
import SelfEsteemChildrenAr from "/subs/self-esteem-identity.ar.vtt";
import SelfEsteemChildrenEn from "/subs/self-esteem-identity.en.vtt";
import SleepProblemsChildrenAr from "/subs/sleep-problems.ar.vtt";
import SleepProblemsChildrenEn from "/subs/sleep-problems.en.vtt";
import SelfHarmChildrenAr from "/subs/self-harm.ar.vtt";
import SelfHarmChildrenEn from "/subs/self-harm.en.vtt";
import type {
  AdultExerciseGroup,
  AdultExerciseGroupMetadata,
  CategoryMetadata,
  ExerciseCategory,
  ExerciseMetadata,
  PsychoeducationVideoMetadata,
} from "@/lib/types/exercise/metadata";
import type { ChildEmotionGroupId } from "@/lib/types/exercise/childSession";

export const ADULT_EXERCISE_GROUP_ORDER: AdultExerciseGroup[] = [
  "body",
  "breathing",
  "imagination",
  "resources",
  "grounding-and-coping",
];

export const ADULT_EXERCISE_GROUPS: AdultExerciseGroupMetadata[] = [
  {
    id: "body",
    titleKey: "exerciseGroups.body.title",
    subtitleKey: "exerciseGroups.body.subtitle",
    icon: LeafIcon,
  },
  {
    id: "breathing",
    titleKey: "exerciseGroups.breathing.title",
    subtitleKey: "exerciseGroups.breathing.subtitle",
    icon: FingerIcon,
  },
  {
    id: "imagination",
    titleKey: "exerciseGroups.imagination.title",
    subtitleKey: "exerciseGroups.imagination.subtitle",
    icon: CloudIcon,
  },
  {
    id: "resources",
    titleKey: "exerciseGroups.resources.title",
    subtitleKey: "exerciseGroups.resources.subtitle",
    icon: StarIcon,
  },
  {
    id: "grounding-and-coping",
    titleKey: "exerciseGroups.grounding-and-coping.title",
    subtitleKey: "exerciseGroups.grounding-and-coping.subtitle",
    icon: LeafIcon,
  },
];

const ADULT_EXERCISE_GROUP_BY_ID: Record<string, AdultExerciseGroup> = {
  "body-exercise": "body",
  relaxation: "body",
  "guided-relaxation": "breathing",
  "finger-breathing": "breathing",
  "three-breath": "breathing",
  "neurogenic-tremoring": "body",
  "butterfly-hug": "body",
  eft: "body",
  imagination: "imagination",
  "personal-sources": "resources",
  "diary-adults": "resources",
  drawing: "resources",
  "tree-of-life": "resources",
  "social-network": "resources",
  "conversing-together": "resources",
  "positive-imagery": "resources",
  "one-to-five": "grounding-and-coping",
  "painful-memories": "imagination",
  "pleasant-memories": "imagination",
  "waterfall": "imagination",
  baggage: "imagination",
  // Inner Garden is hidden for now; uncomment to re-enable.
  // "inner-garden": "imagination",
};

export function getExerciseRoute(
  category: ExerciseCategory,
  exerciseId: string,
): string {
  return `/exercises/${category}/${exerciseId}`;
}

export function isValidExerciseRoute(
  exerciseId: string,
  category: ExerciseCategory,
): boolean {
  const exercise = EXERCISE_CATALOG.find((e) => e.id === exerciseId);
  return exercise ? exercise.categories.includes(category) : false;
}

export const CATEGORY: CategoryMetadata[] = [
  {
    id: "stress",
    titleKey: "exercises.categories.stress",
    content: "exercises.categories.stress.content",
    image: stressAdultImage,
    audience: "child",
  },
  {
    id: "weakness",
    titleKey: "exercises.categories.weakness",
    content: "exercises.categories.weakness.content",
    image: weaknessAdultImage,
    audience: "child",
  },
  {
    id: "fear",
    titleKey: "exercises.categories.fear",
    content: "exercises.categories.fear.content",
    image: fearAdultImage,
    audience: "child",
  },
  {
    id: "trauma",
    titleKey: "exercises.categories.trauma",
    content: "exercises.categories.trauma.content",
    image: truamaAdultImage,
    audience: "adult",
  },
  {
    id: "sleep",
    titleKey: "exercises.categories.sleep",
    content: "exercises.categories.sleep.content",
    image: sleepAdultImage,
    audience: "adult",
  },
  {
    id: "concentration",
    titleKey: "exercises.categories.concentration",
    content: "exercises.categories.concentration.content",
    image: concentrationAdultImage,
    audience: "adult",
  },
  {
    id: "substance-use",
    titleKey: "exercises.categories.substanceUse",
    content: "exercises.categories.substanceUse.content",
    image: substanceUseAdultImage,
    audience: "adult",
  },
  {
    id: "self-inflicted-injuries",
    titleKey: "exercises.categories.selfInflictedInjuries",
    content: "exercises.categories.selfInflictedInjuries.content",
    image: selfInflictedInjuriesAdultImage,
    audience: "adult",
  },
  {
    id: "guilt-feelings",
    titleKey: "exercises.categories.guiltFeelings",
    content: "exercises.categories.guiltFeelings.content",
    image: guiltFeelingsAdultImage,
    audience: "adult",
  },
  {
    id: "physical-pain",
    titleKey: "exercises.categories.physicalPain",
    content: "exercises.categories.physicalPain.content",
    image: physicalPainAdultImage,
    audience: "adult",
  },
  {
    id: "anger",
    titleKey: "exercises.categories.anger",
    content: "exercises.categories.anger.content",
    image: angerAdultImage,
    audience: "adult",
  },
  {
    id: "depression",
    titleKey: "exercises.categories.depression",
    content: "exercises.categories.depression.content",
    image: depressionAdultImage,
    audience: "adult",
  },
  {
    id: "anxiety",
    titleKey: "exercises.categories.anxiety",
    content: "exercises.categories.anxiety.content",
    image: anxietyAdultImage,
    audience: "adult",
  },
  {
    id: "suicide-ideation",
    titleKey: "exercises.categories.suicide-ideation",
    content: "exercises.categories.suicide-ideation.content",
    image: suicideIdeationAdultImage,
    audience: "adult",
  },
  {
    id: "nightmares",
    titleKey: "exercises.categories.nightmares",
    content: "exercises.categories.nightmares.content",
    image: nightmaresAdultImage,
    audience: "adult",
  },
  {
    id: "flashbacks",
    titleKey: "exercises.categories.flashbacks",
    content: "exercises.categories.flashbacks.content",
    image: flashbacksAdultImage,
    audience: "adult",
  },
];

export const PSYCHOEDUCATION_VIDEOS: PsychoeducationVideoMetadata[] = [
  {
    id: "trauma-video-1",
    titleKey: "traumas.video1.title",
    descriptionKey: "traumas.video1.description",
    audience: "adult",
    videoSrc: TraumaVideo1Mp4,
    videoSources: [
      { src: TraumaVideo1Webm, type: "video/webm" },
      { src: TraumaVideo1Mp4, type: "video/mp4" },
    ],
    poster: SarahVideoThumbnail,
    duration: "4",
    category: "trauma",
  },
  {
    id: "trauma-video-2",
    titleKey: "traumas.video2.title",
    descriptionKey: "traumas.video2.description",
    audience: "adult",
    videoSrc: TraumaVideo2Mp4,
    videoSources: [
      { src: TraumaVideo2Webm, type: "video/webm" },
      { src: TraumaVideo2Mp4, type: "video/mp4" },
    ],
    poster: SarahVideoThumbnail,
    duration: "2",
    category: "trauma",
  },
  {
    id: "grief-and-loss",
    titleKey: "children.video.griefAndLoss.title",
    descriptionKey: "children.video.griefAndLoss.description",
    audience: "child",
    videoSrc: GriefAndLossVideoMp4,
    videoSources: [
      { src: GriefAndLossVideoWebm, type: "video/webm" },
      { src: GriefAndLossVideoMp4, type: "video/mp4" },
    ],
    poster: GriefAndLossPoster,
    subtitleTracks: [
      { src: GriefAndLossChildrenAr, srcLang: "ar", label: "Arabic", default: true },
      { src: GriefAndLossChildrenEn, srcLang: "en", label: "English" },
    ],
    duration: "3",
    childEmotionGroupId: "anxiety-fear",
  },
  {
    id: "understanding-depression-sadness",
    titleKey: "children.video.understandingDepressionSadness.title",
    descriptionKey: "children.video.understandingDepressionSadness.description",
    audience: "child",
    videoSrc: UnderstandingDepressionVideoMp4,
    videoSources: [
      { src: UnderstandingDepressionVideoWebm, type: "video/webm" },
      { src: UnderstandingDepressionVideoMp4, type: "video/mp4" },
    ],
    poster: UnderstandingDepressionPoster,
    subtitleTracks: [
      { src: UnderstandingDepressionChildrenAr, srcLang: "ar", label: "Arabic", default: true },
      { src: UnderstandingDepressionChildrenEn, srcLang: "en", label: "English" },
    ],
    duration: "3",
    childEmotionGroupId: "anxiety-fear",
  },
  {
    id: "self-esteem-identity",
    titleKey: "children.video.selfEsteemIdentity.title",
    descriptionKey: "children.video.selfEsteemIdentity.description",
    audience: "child",
    videoSrc: SelfEsteemVideoMp4,
    videoSources: [
      { src: SelfEsteemVideoWebm, type: "video/webm" },
      { src: SelfEsteemVideoMp4, type: "video/mp4" },
    ],
    poster: SelfEsteemPoster,
    subtitleTracks: [
      { src: SelfEsteemChildrenAr, srcLang: "ar", label: "Arabic", default: true },
      { src: SelfEsteemChildrenEn, srcLang: "en", label: "English" },
    ],
    duration: "3",
    childEmotionGroupId: "social",
   },
   {
    id: "nightmares-video-1",
    titleKey: "nightmares.video1.title",
    descriptionKey: "nightmares.video1.description",
    audience: "adult",
    videoSrc: NightmaresVideoMp4,
    videoSources: [
      { src: NightmaresVideoWebm, type: "video/webm" },
      { src: NightmaresVideoMp4, type: "video/mp4" },
    ],
    poster: nightmaresAdultImage,
    duration: "3",
    category: "nightmares",
  },
  {
    id: "flashbacks-video-1",
    titleKey: "flashbacks.video1.title",
    descriptionKey: "flashbacks.video1.description",
    audience: "adult",
    videoSrc: FlashbacksVideoMp4,
    videoSources: [
      { src: FlashbacksVideoWebm, type: "video/webm" },
      { src: FlashbacksVideoMp4, type: "video/mp4" },
    ],
    poster: FlashbacksThumbnail,
    duration: "3",
    category: "flashbacks",
  },
  {
    id: "sleep-problems",
    titleKey: "children.video.sleepProblems.title",
    descriptionKey: "children.video.sleepProblems.description",
    audience: "child",
    videoSrc: SleepProblemsVideoMp4,
    videoSources: [
      { src: SleepProblemsVideoWebm, type: "video/webm" },
      { src: SleepProblemsVideoMp4, type: "video/mp4" },
    ],
    poster: SleepProblemsPoster,
    subtitleTracks: [
      { src: SleepProblemsChildrenAr, srcLang: "ar", label: "Arabic", default: true },
      { src: SleepProblemsChildrenEn, srcLang: "en", label: "English" },
    ],
    duration: "3",
    childEmotionGroupId: "sleep",
  },
  {
    id: "self-harm",
    titleKey: "children.video.selfHarm.title",
    descriptionKey: "children.video.selfHarm.description",
    audience: "child",
    videoSrc: SelfHarmVideoMp4,
    videoSources: [
      { src: SelfHarmVideoWebm, type: "video/webm" },
      { src: SelfHarmVideoMp4, type: "video/mp4" },
    ],
    poster: SelfHarmPoster,
    subtitleTracks: [
      { src: SelfHarmChildrenAr, srcLang: "ar", label: "Arabic", default: true },
      { src: SelfHarmChildrenEn, srcLang: "en", label: "English" },
    ],
    duration: "2",
    childEmotionGroupId: "anger",
  },
];

export const EXERCISE_CATALOG: ExerciseMetadata[] = [
  // stress Exercises
  {
    id: "humming-bee-breath",
    titleKey: "hummingBee.title",
    descriptionKey: "hummingBee.description",
    audience: "child",
    categories: ["stress", "self-inflicted-injuries", "depression"],
    route: "/exercises/stress/humming-bee-breath",
    ageRange: { min: 3, max: 9 },
    icon: NetworkIcon,
  },
  {
    id: "relaxation",
    titleKey: "stress.exercises.relaxation",
    descriptionKey: "stress.exercises.relaxation.description",
    audience: "both",
    categories: [
      "stress",
      "trauma",
      "sleep",
      "substance-use",
      "physical-pain",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/relaxation",
    ageRange: { min: 13, max: 18 },
    icon: RoseIcon,
  },
  {
    id: "body-exercise",
    titleKey: "stress.exercises.bodyExercise",
    descriptionKey: "stress.exercises.bodyExercise.description",
    audience: "both",
    categories: [
      "stress",
      "trauma",
      "concentration",
      "substance-use",
      "physical-pain",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/body-exercise",
    ageRange: { min: 13, max: 18 },
    icon: LeafIcon,
  },
  {
    id: "painful-memories",
    titleKey: "painfulMemories.title",
    descriptionKey: "painfulMemories.description",
    audience: "adult",
    categories: [
      "trauma",
      "substance-use",
      "self-inflicted-injuries",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/painful-memories",
    icon: LeafIcon,
  },
  {
    id: "pleasant-memories",
    titleKey: "pleasantMemories.title",
    descriptionKey: "pleasantMemories.description",
    audience: "adult",
    categories: [
      "trauma",
      "substance-use",
      "self-inflicted-injuries",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/pleasant-memories",
    icon: LeafIcon,
  },
  {
    id: "waterfall",
    titleKey: "waterfall.title",
    descriptionKey: "waterfall.description",
    audience: "adult",
    categories: [
      "trauma",
      "substance-use",
      "self-inflicted-injuries",
      "depression",
      "physical-pain",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/waterfall",
    icon: LeafIcon,
  },
  {
    id: "baggage",
    titleKey: "baggage.title",
    descriptionKey: "baggage.description",
    audience: "adult",
    categories: [
      "anxiety",
      "sleep",
      "nightmares",
      "flashbacks",
      "depression",
      "trauma",
      "suicide-ideation",
      "anger",
      "physical-pain",
    ],
    route: "/exercises/baggage",
    icon: CloudIcon,
  },
  // Inner Garden is hidden for now; uncomment to re-enable.
  // {
  //   id: "inner-garden",
  //   titleKey: "innerGarden.title",
  //   descriptionKey: "innerGarden.description",
  //   audience: "adult",
  //   categories: [
  //     "anxiety",
  //     "sleep",
  //     "nightmares",
  //     "flashbacks",
  //     "depression",
  //     "trauma",
  //     "suicide-ideation",
  //     "anger",
  //     "physical-pain",
  //   ],
  //   route: "/exercises/inner-garden",
  //   icon: CloudIcon,
  // },
  {
    id: "drawing",
    titleKey: "drawing.title",
    descriptionKey: "drawing.description",
    audience: "adult",
    categories: [
      "stress",
      "trauma",
      "concentration",
      "substance-use",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "flashbacks",
    ],
    route: "/exercises/drawing",
    icon: EditIcon,
  },

  // fear Exercises
  {
    id: "happy-place",
    titleKey: "happy-place.title",
    descriptionKey: "happy-place.description",
    audience: "child",
    categories: ["fear", "self-inflicted-injuries", "depression"],
    route: "/exercises/fear/happy-place",
    ageRange: { min: 3, max: 18 },
    icon: PencilIcon,
  },
  {
    id: "grounding-walk",
    titleKey: "groundingWalk.title",
    descriptionKey: "groundingWalk.description",
    audience: "child",
    categories: ["fear", "self-inflicted-injuries", "depression"],
    route: "/exercises/fear/grounding-walk",
    ageRange: { min: 13, max: 18 },
    icon: LeafIcon,
  },
  {
    id: "strengths-map",
    titleKey: "strengthsMap.title",
    descriptionKey: "strengthsMap.description",
    audience: "child",
    categories: ["fear"],
    route: "/exercises/fear/strengths-map",
    ageRange: { min: 10, max: 18 },
  },
  {
    id: "imagination",
    titleKey: "imagination.title",
    descriptionKey: "imagination.description",
    audience: "adult",
    categories: [
      "fear",
      "stress",
      "trauma",
      "sleep",
      "substance-use",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/imagination",
    icon: CloudIcon,
  },
  {
    id: "finger-breathing",
    titleKey: "breathing.fingerBreath.title",
    descriptionKey: "stress.exercises.fingerBreath.description",
    audience: "both",
    categories: [
      "fear",
      "trauma",
      "concentration",
      "sleep",
      "substance-use",
      "physical-pain",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/finger-breathing",
    ageRange: { min: 13, max: 18 },
    icon: FingerIcon,
  },
  {
    id: "guided-relaxation",
    titleKey: "breathing.guidedRelax.title",
    descriptionKey: "stress.exercises.breathing.description",
    audience: "both",
    categories: [
      "fear",
      "trauma",
      "concentration",
      "sleep",
      "substance-use",
      "physical-pain",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/guided-relaxation",
    ageRange: { min: 13, max: 18 },
    icon: MoonIcon,
  },
  {
    id: "three-breath",
    titleKey: "threeBreath.title",
    descriptionKey: "threeBreath.description",
    audience: "adult",
    categories: [
      "trauma",
      "sleep",
      "substance-use",
      "physical-pain",
      "self-inflicted-injuries",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/three-breath",
    icon: MoonIcon,
  },
  {
    id: "neurogenic-tremoring",
    titleKey: "neurogenicTremoring.title",
    descriptionKey: "neurogenicTremoring.description",
    audience: "adult",
    categories: [
      "trauma",
      "concentration",
      "substance-use",
      "physical-pain",
      "self-inflicted-injuries",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/neurogenic-tremoring",
    icon: LeafIcon,
  },
  {
    id: "butterfly-hug",
    titleKey: "butterflyHug.title",
    descriptionKey: "butterflyHug.description",
    audience: "adult",
    categories: [
      "trauma",
      "concentration",
      "sleep",
      "substance-use",
      "self-inflicted-injuries",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "flashbacks",
    ],
    route: "/exercises/butterfly-hug",
    icon: RoseIcon,
  },

  // weakness Exercises
  {
    id: "anger-iceberg",
    titleKey: "angerIceberg.title",
    descriptionKey: "angerIceberg.description",
    audience: "child",
    categories: ["weakness", "self-inflicted-injuries", "depression"],
    route: "/exercises/weakness/anger-iceberg",
    ageRange: { min: 7, max: 12 },
    icon: StarIcon,
  },
  {
    id: "circle-of-control",
    titleKey: "circleControl.title",
    descriptionKey: "circleControl.description",
    audience: "child",
    categories: ["weakness", "self-inflicted-injuries", "depression"],
    route: "/exercises/weakness/circle-of-control",
    ageRange: { min: 6, max: 16 },
    icon: NetworkIcon,
  },
  {
    id: "my-brave-story",
    titleKey: "myBraveStory.title",
    descriptionKey: "myBraveStory.description",
    audience: "child",
    categories: ["weakness", "self-inflicted-injuries", "depression"],
    route: "/exercises/weakness/my-brave-story",
    ageRange: { min: 6, max: 16 },
    icon: LeafIcon,
  },
  {
    id: "diary-children",
    titleKey: "diary.children.title",
    descriptionKey: "diary.children.short.description",
    audience: "child",
    categories: ["weakness", "self-inflicted-injuries", "depression"],
    route: "/exercises/weakness/diary-children",
    ageRange: { min: 13, max: 18 },
    icon: PencilIcon,
  },
  {
    id: "tree-of-life",
    titleKey: "treeOfLife.title",
    descriptionKey: "treeOfLife.description",
    audience: "both",
    categories: [
      "weakness",
      "trauma",
      "substance-use",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "suicide-ideation",
    ],
    route: "/exercises/tree-of-life",
    ageRange: { min: 13, max: 18 },
    icon: TreeIcon,
  },
  {
    id: "personal-sources",
    titleKey: "personalSources.title",
    descriptionKey: "weakness.exercises.personalSources.description",
    audience: "both",
    categories: [
      "weakness",
      "trauma",
      "substance-use",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "suicide-ideation",
    ],
    route: "/exercises/personal-sources",
    ageRange: { min: 13, max: 18 },
    icon: StarIcon,
  },
  {
    id: "social-network",
    titleKey: "weakness.exercises.network",
    descriptionKey: "weakness.exercises.network.description",
    audience: "both",
    categories: [
      "weakness",
      "trauma",
      "substance-use",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "suicide-ideation",
    ],
    route: "/exercises/social-network",
    ageRange: { min: 13, max: 18 },
    icon: NetworkIcon,
  },
  {
    id: "conversing-together",
    titleKey: "conversingTogether.title",
    descriptionKey: "conversingTogether.intro.title",
    audience: "adult",
    categories: [
      "weakness",
      "trauma",
      "substance-use",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
    ],
    route: "/exercises/conversing-together",
    icon: ImaginationIcon,
  },
  {
    id: "diary-adults",
    titleKey: "weakness.exercises.diary",
    descriptionKey: "weakness.exercises.diary.description",
    audience: "adult",
    categories: [
      "weakness",
      "trauma",
      "substance-use",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
    ],
    route: "/exercises/diary-adults",
    icon: PencilIcon,
  },
  {
    id: "positive-imagery",
    titleKey: "positiveImagery.title",
    descriptionKey: "positiveImagery.exercises.positiveImageryExercise",
    audience: "adult",
    categories: [
      "weakness",
      "trauma",
      "sleep",
      "substance-use",
      "physical-pain",
      "self-inflicted-injuries",
      "guilt-feelings",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
    ],
    route: "/exercises/positive-imagery",
    icon: ImagineIcon,
  },
  {
    id: "one-to-five",
    titleKey: "oneFive.title",
    descriptionKey: "oneFive.description",
    audience: "adult",
    categories: [
      "trauma",
      "concentration",
      "sleep",
      "substance-use",
      "self-inflicted-injuries",
      "depression",
      "anger",
      "anxiety",
      "suicide-ideation",
      "nightmares",
      "flashbacks",
    ],
    route: "/exercises/one-to-five",
    icon: LeafIcon,
  },
  {
    id: "eft",
    titleKey: "eft.title",
    descriptionKey: "eft.description",
    audience: "adult",
    categories: [
      "trauma",
      "sleep",
      "concentration",
      "self-inflicted-injuries",
      "anger",
      "substance-use",
      "anxiety"
    ],
    route: "/exercises/eft",
    icon: RoseIcon,
  },
];

// Get exercises filtered by audience

export function getExercisesByAudience(
  audience: "adult" | "child",
): ExerciseMetadata[] {
  return EXERCISE_CATALOG.filter(
    (exercise) =>
      exercise.audience === audience || exercise.audience === "both",
  );
}

//  Get exercises filtered by audience and category

export function getExercisesByAudienceAndCategory(
  audience: "adult" | "child",
  category: ExerciseCategory,
): ExerciseMetadata[] {
  return getExercisesByAudience(audience).filter((exercise) =>
    exercise.categories.includes(category),
  );
}

//  Get categories filtered by audience

export function getCategoriesByAudience(
  audience: "adult" | "child",
): CategoryMetadata[] {
  return CATEGORY.filter(
    (category) =>
      category.audience === audience || category.audience === "both",
  );
}

export function getPsychoeducationVideos(
  audience: "adult" | "child",
  category?: ExerciseCategory,
): PsychoeducationVideoMetadata[] {
  const videosForAudience = PSYCHOEDUCATION_VIDEOS.filter(
    (video) => video.audience === audience || video.audience === "both",
  );

  if (category) {
    return videosForAudience.filter((video) => video.category === category);
  }

  return videosForAudience;
}

export function getPsychoeducationVideoByEmotionGroup(
  groupId: ChildEmotionGroupId,
): PsychoeducationVideoMetadata | undefined {
  return PSYCHOEDUCATION_VIDEOS.find(
    (video) => video.childEmotionGroupId === groupId,
  );
}

export function getPsychoeducationVideoById(
  id: string,
): PsychoeducationVideoMetadata | undefined {
  return PSYCHOEDUCATION_VIDEOS.find((video) => video.id === id);
}

export function getExerciseById(id: string): ExerciseMetadata | undefined {
  return EXERCISE_CATALOG.find((exercise) => exercise.id === id);
}

export function getAdultExerciseGroupById(
  id: AdultExerciseGroup,
): AdultExerciseGroupMetadata | undefined {
  return ADULT_EXERCISE_GROUPS.find((group) => group.id === id);
}

export function isAdultExerciseGroup(
  value: unknown,
): value is AdultExerciseGroup {
  return (
    typeof value === "string" &&
    ADULT_EXERCISE_GROUP_ORDER.includes(value as AdultExerciseGroup)
  );
}

export function getAdultExerciseGroupsForSymptom(
  category: ExerciseCategory,
): AdultExerciseGroupMetadata[] {
  const exercises = getExercisesByAudienceAndCategory("adult", category);
  const availableGroups = new Set<AdultExerciseGroup>();

  for (const exercise of exercises) {
    const group = ADULT_EXERCISE_GROUP_BY_ID[exercise.id];
    if (group) {
      availableGroups.add(group);
    }
  }

  return ADULT_EXERCISE_GROUPS.filter((group) => availableGroups.has(group.id));
}

export function getAdultExercisesBySymptomAndGroup(
  category: ExerciseCategory,
  group: AdultExerciseGroup,
): ExerciseMetadata[] {
  return getExercisesByAudienceAndCategory("adult", category).filter(
    (exercise) => ADULT_EXERCISE_GROUP_BY_ID[exercise.id] === group,
  );
}

export function getCategoryById(
  id: ExerciseCategory,
): CategoryMetadata | undefined {
  return CATEGORY.find((category) => category.id === id);
}

export function getRandomSuggestedExercises(
  audience: "adult" | "child" | "both",
  count: number = 2,
): ExerciseMetadata[] {
  // SSR guard
  if (typeof window === "undefined") {
    const base =
      audience === "both" ? EXERCISE_CATALOG : getExercisesByAudience(audience);
    return base.slice(0, count);
  }

  const storageKey = `suggested_exercises_${audience}_${count}`;

  const exercises =
    audience === "both" ? EXERCISE_CATALOG : getExercisesByAudience(audience);

  if (exercises.length === 0) return [];

  /*Try session cache*/
  try {
    const cached = sessionStorage.getItem(storageKey);
    if (cached) {
      const cachedIds: string[] = JSON.parse(cached);

      const cachedExercises = cachedIds
        .map((id) => exercises.find((e) => e.id === id))
        .filter((e): e is ExerciseMetadata => Boolean(e));

      if (cachedExercises.length === count) {
        return cachedExercises;
      }
    }
  } catch {
    // ignore corrupted cache
  }

  /* Group exercises by category */
  const categoryMap = new Map<string, ExerciseMetadata[]>();

  for (const exercise of exercises) {
    for (const category of exercise.categories) {
      if (!categoryMap.has(category)) {
        categoryMap.set(category, []);
      }
      categoryMap.get(category)!.push(exercise);
    }
  }

  /* Group exercises by category */
  const shuffle = <T>(array: T[]): T[] => {
    const result = [...array];
    for (let i = result.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [result[i], result[j]] = [result[j], result[i]];
    }
    return result;
  };

  /* Pick one exercise per category */
  const selected: ExerciseMetadata[] = [];
  const usedIds = new Set<string>();

  const shuffledCategories = shuffle([...categoryMap.keys()]);

  for (const category of shuffledCategories) {
    if (selected.length >= count) break;

    const pool = shuffle(categoryMap.get(category)!);
    const candidate = pool.find((e) => !usedIds.has(e.id));

    if (candidate) {
      selected.push(candidate);
      usedIds.add(candidate.id);
    }
  }

  /* Fill remaining slots randomly */
  if (selected.length < count) {
    const remaining = shuffle(exercises.filter((e) => !usedIds.has(e.id)));

    selected.push(...remaining.slice(0, count - selected.length));
  }

  /* Cache result */
  sessionStorage.setItem(storageKey, JSON.stringify(selected.map((e) => e.id)));

  return selected;
}
